import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  fullWidth: {
    width: "100%",
  },
  paper: {
    maxHeight: "100vh",
    height: "100vh",
  },
  root: {
    // marginLeft: -8,
    margin: 0,
    borderRadius: 0,
  },
  btn: {
    textTransform: "capitalize",
  },
  header: {
    height: 60,
  },
  accordion: {
    position: "relative",
    backgroundColor: "#D6E0FF",
    "&::before": {
      height: 0,
    },
  },
  expanded: {
    margin: "0 !important",
  },
  content: {
    display: "flex",
    flexDirection: "column",
  },
  qty: {
    padding: 5,
    border: "1px solid grey",
    borderRadius: 5,
  },
  padding: {
    padding: 20,
  },
  pesanan: {
    padding: 20,
    alignContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  infoCon: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    // backgroundColor: "black"
  },
  info: {
    display: "flex",
    flexDirection: "row",
    fontSize: 17,
    alignItems: "center",
  },
  trackDot: {
    width: 20,
    height: 20,
  },
  trackCon: {
    display: "flex",
    flexDirection: "column",
    fontSize: 17,
    textAlign: "left",
    paddingLeft: 30,
  },
  trackDate: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  connector: {
    backgroundColor: theme.palette.primary.main,
  },
  time: {
    fontSize: 12,
  }
}));

export default useStyles;
